import { RowSelectionState } from "@tanstack/react-table";
import compact from "lodash/compact";
import entries from "lodash/entries";
import find from "lodash/find";
import flatMap from "lodash/flatMap";
import uniqBy from "lodash/uniqBy";
import { Profile, ProfileCustomValue, SkillsFramework, SkillsFrameworkSkill } from "PFCore/types";

export const filterSkillsByTerm = (skills: ProfileCustomValue[] | undefined, searchTerm: string) =>
  (skills || []).filter(({ text, value }) =>
    (text || String(value) || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

export const getSelectedSkillsIds = (rowSelectionState: RowSelectionState) =>
  entries(rowSelectionState)
    .filter(([, isSelected]) => isSelected)
    .map(([id]) => Number(id));

export const getAllFrameworksUniqueSkillsList = (
  skillsFrameworks: SkillsFramework[]
): SkillsFrameworkSkill[] => uniqBy(flatMap(skillsFrameworks, "skills"), "skillId");

export const getSelectedSkills = (
  profile: Profile,
  skillsFrameworks: SkillsFramework[],
  rowSelectionState: RowSelectionState
): (ProfileCustomValue | SkillsFrameworkSkill)[] => {
  const allFrameworksSkills = getAllFrameworksUniqueSkillsList(skillsFrameworks);
  const profileSkills = profile.skills || [];

  return compact(
    getSelectedSkillsIds(rowSelectionState).map(
      (id) => find(profileSkills, { id }) || find(allFrameworksSkills, { skillId: id })
    )
  );
};
